import api from '../utils/api';

class DataroomTemplateService {
  // Get list of available templates for dataroom owners
  async getAvailableTemplates(params = {}) {
    try {
      const queryParams = new URLSearchParams({
        per_page: params.per_page || 20,
        page: params.page || 1,
        ...(params.search && { search: params.search }),
        ...(params.is_active !== undefined && { is_active: params.is_active })
      });

      const response = await api.get(`/datarooms/folder-templates?${queryParams}`);
      return response.data || response;
    } catch (error) {
      console.error('Error fetching available templates:', error);
      throw error;
    }
  }

  // Get single template details
  async getTemplate(id) {
    try {
      const response = await api.get(`/datarooms/folder-templates/${id}`);
      return response.data || response;
    } catch (error) {
      console.error('Error fetching template:', error);
      throw error;
    }
  }

  // Import template to dataroom
  async importTemplate(dataroomUuid, templateId, targetFolder = null) {
    try {
      const payload = {
        template_id: templateId
      };

      // Add target folder if specified
      if (targetFolder) {
        payload.target_folder = targetFolder;
      }

      const response = await api.post(`/datarooms/${dataroomUuid}/import-template`, payload);
      return response.data || response;
    } catch (error) {
      console.error('Error importing template:', error);
      throw error;
    }
  }
}

// Create singleton instance
const dataroomTemplateService = new DataroomTemplateService();

export default dataroomTemplateService;